import React, { PureComponent } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import FlowPostbackStatus from './FlowPostbackStatus';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import Hint from '../../../../components/Hint/Hint';
import { FHTMLMessage, FMessage, ThemedFMessage } from '../../../../hoc/IntlComponents';

const GENERATE_CONVERSION_STATUS = 2;

class FlowPostbackStatuses extends PureComponent {
    static propTypes = {
        statuses: array.isRequired,
        selected: array.isRequired,
        onStatusChange: func.isRequired,
    };

    static defaultProps = {
        statuses: [],
        selected: [GENERATE_CONVERSION_STATUS],
        onStatusChange() { },
    };

    state = {
        enabled: false,
    };

    // componentWillReceiveProps(nextProps) {
    //     this.setState(() => ({
    //         enabled: nextProps.selected.length !== 0,
    //     }));
    // }

    toggleExtraStatuses = () => {
        this.setState(
            prevState => ({
                enabled: !prevState.enabled,
            }),
            () => {
                if (!this.state.enabled) {
                    this.props.onStatusChange([]);
                } else {
                    this.props.onStatusChange([0, 1, 2, 3]);
                }
            },
        );
    };

    handleChange = ({ target }) => {
        const id = parseInt(target.value, 10);
        const { selected } = this.props;

        if (selected.includes(id)) {
            this.props.onStatusChange(selected.filter(status => status !== id));
        } else {
            this.props.onStatusChange([...selected, id]);
            // this.setState(() => ({ enabled: true }));
        }
    };

    render() {
        const { statuses, selected } = this.props;
        const { enabled } = this.state;

        return (
            <div className="postback-statuses">
                <Row>
                    <Col lg="4" md="4" sm="4" xs='4' className='postback-statuses-left-col'>
                        <span className='postback_status_all_wrapper'>
                            <CustomControl
                                id="postback_status_all"
                                className="custom-control-xs"
                                value="all"
                                checked={enabled}
                                onChange={this.toggleExtraStatuses}
                            >
                                <FormattedMessage
                                    id="flow.form.postback.statuses"
                                    defaultMessage="Statuses"
                                />
                            </CustomControl>
                            <Hint
                                id="postback_status_all_hint"
                                title={<FMessage id='flow.form.postback.report-statuses.hint.header' />}
                                text={<FHTMLMessage id='flow.form.postback.report-statuses.hint.body' />}
                            />
                        </span>
                    </Col>
                    <Col lg="8" md="8" sm="8" xs='8'>
                        <ul className="flow-postback-statuses">
                            <Row>
                                {statuses.map(({ id, title }) => (
                                    <Col lg='6' key={id}>
                                        <FlowPostbackStatus
                                            onChange={this.handleChange}
                                            label={(<ThemedFMessage id={`flow.form.postback.statuses.${id}`} />)}
                                            status={id}
                                            checked={selected.includes(id)}
                                        />
                                    </Col>

                                ))}
                            </Row>
                        </ul>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default FlowPostbackStatuses;
